import { FC, CSSProperties } from 'react';
import { createSvgIcon } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { WbBadge } from '../../WbBadge';
import { useStyles } from './style';

const TerminatingSvgIcon = createSvgIcon(
  <>
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12.1825L19.8175 10L16 13.8175L12.1825 10L10 12.1825L13.8175 16L10 19.8175L12.1825 22L16 18.1825L19.8175 22L22 19.8175L18.1825 16L22 12.1825Z"
        fill="#FF5252"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6412 5.4828C23.3704 5.28604 23.093 5.10043 22.8096 4.92616C22.523 4.7499 22.2303 4.58525 21.9322 4.43241C21.6188 4.27165 21.2993 4.12394 20.9749 3.98955L20.2287 5.79114C21.0255 6.12117 21.7863 6.54559 22.4939 7.05952L22.495 7.06037L22.495 7.06038L22.4979 7.06244C24.3843 8.43393 25.7884 10.3672 26.5092 12.5854C26.5095 12.5864 26.5098 12.5874 26.5102 12.5884C27.2303 14.8069 27.2299 17.1963 26.5092 19.4146C26.4291 19.6612 26.3405 19.9042 26.2438 20.1433C26.2323 20.1718 26.2207 20.2003 26.2089 20.2287C26.167 20.3297 26.1237 20.43 26.079 20.5295C25.2921 22.2806 24.0592 23.8032 22.495 24.9396C22.183 25.1663 21.8605 25.3757 21.5289 25.5674C21.361 25.6644 21.1902 25.7572 21.0166 25.8456C20.9192 25.8953 20.8211 25.9434 20.7225 25.9901C19.2536 26.6844 17.6416 27.05 16 27.05V27.05C15.1371 27.05 14.2713 26.949 13.4204 26.7447C12.5696 26.5404 11.7523 26.2374 10.9834 25.8456L10.0981 27.5831C11.0026 28.044 11.9642 28.4005 12.9652 28.6408C13.9662 28.8811 14.9848 29.0001 16 29V29C16.6728 29 17.3413 28.9478 18 28.8453C18.3479 28.7911 18.6931 28.7228 19.0347 28.6408L19.0348 28.6409C19.8234 28.4515 20.5964 28.1879 21.3431 27.8512C21.5311 27.7665 21.7174 27.6771 21.9019 27.5831C22.0739 27.4955 22.2436 27.4042 22.4108 27.3094C23.1357 26.8985 23.8156 26.421 24.4429 25.8853L24.4429 25.8853C25.2228 25.2192 25.9184 24.4654 26.5172 23.6413L26.5172 23.6413C26.9935 22.9857 27.4098 22.2839 27.7588 21.5436C27.847 21.3565 27.9309 21.1669 28.0105 20.9749C28.0351 20.9155 28.0592 20.8559 28.0829 20.7962C28.4385 19.9003 28.6911 18.9737 28.84 18.0337L28.84 18.0336C29 17.023 29.04 15.998 28.9599 14.9801L28.96 14.9801C28.9324 14.63 28.8906 14.2805 28.8346 13.9327C28.7814 13.6021 28.7152 13.2728 28.6362 12.9458C28.5685 12.6657 28.4913 12.3873 28.4046 12.1109C28.3912 12.0681 28.3776 12.0254 28.3638 11.9828C28.3638 11.9828 28.3637 11.9828 28.3637 11.9828C27.7233 10.0117 26.6241 8.23183 25.1683 6.78356C24.6966 6.31435 24.1875 5.87995 23.6444 5.48513L23.6412 5.4828ZM14.9801 3.04009C16.0063 2.95932 17.031 3.00122 18.0337 3.16006L17.7286 5.08605C16.8763 4.95104 16.0054 4.91543 15.133 4.98408C14.2607 5.05273 13.406 5.22416 12.5854 5.49083L11.9828 3.63627C12.9483 3.32253 13.9538 3.12086 14.9801 3.04009ZM10.2264 6.57832L9.20758 4.91565C8.34195 5.44609 7.53556 6.0797 6.80763 6.80763C6.07971 7.53555 5.44609 8.34194 4.91566 9.20757L6.57834 10.2264C7.02921 9.49061 7.56776 8.80521 8.18649 8.18649C8.80522 7.56776 9.49065 7.02919 10.2264 6.57832ZM3.04009 14.98C3.12086 13.9538 3.32254 12.9483 3.63627 11.9828L5.49083 12.5854C5.22415 13.4061 5.05274 14.2607 4.98408 15.133C4.91543 16.0054 4.95105 16.8763 5.08605 17.7286L3.16006 18.0337C3.00122 17.031 2.95932 16.0063 3.04009 14.98ZM3.98955 20.9749L5.79113 20.2287C6.12134 21.0259 6.54606 21.7871 7.06038 22.495C7.5747 23.2029 8.16744 23.8421 8.82362 24.4025L7.55719 25.8853C6.7852 25.226 6.08789 24.4741 5.4828 23.6412C4.8777 22.8084 4.37804 21.9128 3.98955 20.9749Z"
        fill="#FF5252"
      />
    </svg>
  </>,
  'TerminatingIcon',
);

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const TerminatingIcon: FC<Props> = ({ style, variant = 'default' }) => {
  const classes = useStyles();
  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title="The execution is being terminated"
      icon={
        variant === 'reduced' ? (
          <span>
            <TerminatingSvgIcon className={classes.icon} style={style} />{' '}
          </span>
        ) : (
          <WbBadge color="warning" startIcon={<ClearIcon fontSize="small" />}>
            Terminating
          </WbBadge>
        )
      }
    />
  );
};
